import router from '@/router/index'
import store from '@/store/index'
router.beforeEach((to, from, next) => {
  if (window.noticeSetInt) {
    clearInterval(window.noticeSetInt);
  }
  if (window.styleLeft) {
    clearInterval(window.styleLeft);
  }
  if (!store.getters.user) {

    store.dispatch('getUser', {}).then(res => {

    })
  }
  if (store.getters.menu) {

    next();
    document.body.scrollTop = document.documentElement.scrollTop = 0

  } else {
    store.dispatch('getMenu', { op: "findPortalMenuTree" }).then(res => {

      next();
      document.body.scrollTop = document.documentElement.scrollTop = 0
    })
  }

});